import {Component, Input} from '@angular/core';
import {DeviceConfigurationResponseModel} from '../../../../shared/services/merchant/deviceConfigurationResponse.model';
import QRCode from 'qrcode';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'app-device-qr-code',
  templateUrl: './device-qr-code.component.html',
  styleUrls: ['./device-qr-code.component.scss']
})
export class DeviceQrCodeComponent {
  @Input() set deviceConfiguration(config: DeviceConfigurationResponseModel) {
    if (config) {
      this.config = config;
      this.createQRCode(config);
    }
  }

  public qrCode: SafeHtml;
  public config: DeviceConfigurationResponseModel;

  constructor(private sanitizer: DomSanitizer) {
  }

  public createQRCode(config: DeviceConfigurationResponseModel): void {
    QRCode.toString(JSON.stringify(config), { type: 'svg' })
      .then(svg => {
        const doc = new DOMParser().parseFromString(svg, 'image/svg+xml');
        const svgEl = doc.documentElement; // <svg>

        svgEl.setAttribute('width', '100%');
        svgEl.setAttribute('height', '100%');

        const finalSvg = new XMLSerializer().serializeToString(svgEl);
        this.qrCode = this.sanitizer.bypassSecurityTrustHtml(finalSvg);
      });
  }
}
